import { render, staticRenderFns } from "./Boxwrap.vue?vue&type=template&id=12fe5923"
import script from "./Boxwrap.vue?vue&type=script&lang=js"
export * from "./Boxwrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports